export default {
    formInit() {
        return {
            selectedProduct: "all",
            productOptions: [{ value: "all", text: "All Products" }],
            productName: "",
            appVisibility: true,
            instantGrat: false,
            instantGratCSV: null,
            autoIssue: false,
            forPackage: false,
            selectedCurrency: "PHP",
            currencyOptions: [
                { value: "PHP", text: "PHP" },
                { value: "USD", text: "USD" }
            ],
            image: "",
            price: 0,
            points: 0,
            quantity: 1,
            rewardDescription: "",
            freeReward: "",
            branch: [],
            category: [],
            brandUuid: "",
            validityPeriod: "",
            selectedTargetSegment: 1,
            redeemInstruction: "",
            displayInstruction: false,
            targetSegmentOptions: [
                { text: "Segment 1", value: 1 },
                { text: "Segment 2", value: 2 }
            ],
            selfClaim: false,
            forMarketplace: false,
            is_punch_card: false,
            punch_card_visible: false,
            is_used_in_campaign: false
        };
    },
    initializeForm() {
        return {
            type: "Free",
            name: "",
            image: "",
            description: "",
            show_redeem_instruction: true,
            redeem_instruction: "",
            show_display_instruction: true, // FOR SHOWING TERMS AND CONDITIONS
            display_instruction_terms: "", // TERMS AND CONDITIONS
            rewards_label: "",
            start: "",
            end: "",
            on_duration: true,
            customer_app: false,
            web: false,
            gcash: false,
            bau: false,
            privilege_card: false,
            membership_tier: false,
            categories: "",
            price: "",
            points: 0,
            inventory: "",
            is_unlimited_inventory: false,
            voucher_type: "Item-Based",
            voucher_discount_parameter: "Php",
            voucher_discount_value: "",
            duration_type: "Standard",
            duration_validity: [],
            grace_period_start_of_month: null,
            grace_period_end_of_month: null,
            frequency_type: "unlimited",
            frequency_parameter: "Daily",
            frequency_value: null,
            instant_grat_type: "Rewards",
            issue_type: "Auto Issued",
            instant_grat_csv: null,
            is_points_free: false,
            assign_to_product: false, // TODO: USE CORRECT FIELD
            survey: false,
            is_punch_card: false,
            punch_card_visible: false,
            is_first_load: true
        }
    }
};
